<form [formGroup]="passwordForm" class="tw-max-w-[497px] tw-w-full tw-mx-auto">
    <div class="tw-mb-[30px] tw-text-[18px] tw-text-[#000000] tw-font-bold">
        {{ "RESET_PASSWORD.RESET_PASSWORD_TITLE" | translate }}
    </div>
    <input-general
        class="tw-block tw-mt-[10px] tw-w-[100%]"
        [mandatoryField]="true"
        [label]="'COMMON.CURRENT_PASSWORD' | translate"
        [placeHolder]="'**********'"
        [hideInput]="true"
        [controlName]="'currentPassword'"
        [errors]="
            getErrorsPassword(
                'currentPassword',
                'COMMON.CURRENT_PASSWORD' | translate
            )
        "
    ></input-general>
    <input-general
        class="tw-block tw-mt-[10px] tw-w-[100%]"
        [mandatoryField]="true"
        [label]="'PROFILE.NEW_PASSWORD' | translate"
        [placeHolder]="'**********'"
        [hideInput]="true"
        [strength]="pswdStrength"
        [strengthLabel]="pswdStrengthLabel"
        [strengthColor]="pswdStrengthColor"
        [controlName]="'newPassword'"
        [errors]="
            getErrorsPassword('newPassword', 'PROFILE.NEW_PASSWORD' | translate)
        "
        (keyup)="checkPasswordStatus($event)"
    ></input-general>
    <input-general
        class="tw-block tw-mt-[10px] tw-w-[100%]"
        [mandatoryField]="true"
        [label]="'FORM.CONFIRM_PASSWORD' | translate"
        [placeHolder]="'**********'"
        [hideInput]="true"
        [controlName]="'confirmPassword'"
        [errors]="
            getErrorsPassword(
                'confirmPassword',
                'FORM.CONFIRM_PASSWORD_2' | translate
            )
        "
        (paste)="disablePaste($event)"
    ></input-general>

    <button
        class="tw-mt-4 tw-block tw-w-full tw-py-4 tw-rounded-full tw-bg-[#FFA53C] tw-text-white"
        (click)="onResetPassword()"
    >
        {{ "COMMON.RESET" | translate }}
    </button>
</form>
